import { Box, Text, Progress, VStack, HStack, Badge } from "@chakra-ui/react";
import { CampaignProgress } from "../../../api/clientUser/getClientAnalytics";

interface CampaignProgressBarProps {
  progress: CampaignProgress;
}

export const CampaignProgressBar = ({ progress }: CampaignProgressBarProps) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount / 100);
  };

  return (
    <Box
      bg="white"
      p={8}
      borderRadius="24px"
      boxShadow="0 4px 20px rgba(0, 0, 0, 0.08)"
      border="1px solid"
      borderColor="gray.100"
    >
      <VStack align="stretch" spacing={6}>
        <HStack justify="space-between" align="center">
          <Box>
            <Text fontSize="sm" fontWeight="600" color="gray.600" textTransform="uppercase" letterSpacing="wide" mb={2}>
              Campaign Progress
            </Text>
            <Text fontSize="4xl" fontWeight="800" color="#1A202C">
              {formatCurrency(progress.raised)}
            </Text>
            <Text fontSize="md" color="gray.500" fontWeight="500">
              of {formatCurrency(progress.goal)} goal
            </Text>
          </Box>
          <Box textAlign="right">
            <Text fontSize="5xl" fontWeight="900" color="#339CFF">
              {progress.percentage}%
            </Text>
            {progress.daysRemaining !== null && (
              <Badge
                colorScheme={progress.daysRemaining > 7 ? "green" : progress.daysRemaining > 3 ? "yellow" : "red"}
                fontSize="sm"
                px={3}
                py={1}
                borderRadius="full"
                mt={2}
              >
                {progress.daysRemaining} days left
              </Badge>
            )}
          </Box>
        </HStack>

        <Box>
          <Progress
            value={progress.percentage}
            size="lg"
            colorScheme="blue"
            borderRadius="full"
            bg="gray.100"
            sx={{
              "& > div": {
                background: "linear-gradient(90deg, #339CFF 0%, #1a365d 100%)",
              },
            }}
          />
        </Box>

        <HStack justify="space-between" fontSize="sm" color="gray.600" fontWeight="500">
          <Text>
            {progress.raised > 0 ? (
              <>
                {formatCurrency(progress.goal - progress.raised)} to go
              </>
            ) : (
              "Start fundraising!"
            )}
          </Text>
          {progress.percentage >= 100 && (
            <Badge colorScheme="green" fontSize="sm" px={3} py={1}>
              Goal Reached! 🎉
            </Badge>
          )}
        </HStack>
      </VStack>
    </Box>
  );
};
